/* src/app/shared/dialog/tv-confirm-popup/tv-confirm-popup.component.scss */
.popup-main-content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;
  border-radius: 16px;
}
.popup-title {
  font: 400 22px FranceTV Brown;
}
.main-content-container {
  margin-top: 15px;
  margin-bottom: 15px;
  font: 400 18px FranceTV Brown;
  width: 100%;
}
.list-item {
  padding: 15px;
  color: #001A33;
  font: 400 14px FranceTV Brown;
}
.list-content-wrapper {
  display: flex;
  flex-direction: column;
  max-height: 480px;
  border-radius: 5px;
  width: 100%;
  border: 1px solid #DFEBF7;
  margin-top: 15px;
}
.list-content-wrapper > div {
  border-top: 1px solid #DFEBF7;
}
.list-content-wrapper > div:first-child {
  border-top: none;
}
.buttons-container {
  display: flex;
  margin-left: auto;
  align-items: center;
}
.abandon-button {
  margin-right: 10px;
}
/*# sourceMappingURL=tv-confirm-popup.component.css.map */
